import React, { useState } from "react";
import "./AboutMePart.css";
import { getTechLogoUrl, getCustomElementUrl } from "../../utils/cloudinary";
import EducationListElement from "../educationListElement/EducationListElement";
import educationContent from "../../static/education_content.json";

// Cloudinary URLs for images
const LinkedInLogo = getTechLogoUrl("linkedin_logo");
const GithubLogo = getTechLogoUrl("github_logo");
const whiteArrow = getCustomElementUrl("white_arrow_to_be_used_on_buttons");
const Location = getCustomElementUrl("location_icon");
const Email = getCustomElementUrl("email_icon");
const copy_icon = getCustomElementUrl("copy_icon");
const checkmark_icon = getCustomElementUrl("checkmark_icon");

const AboutMePart = () => {
    const [flash, setFlash] = useState(false);
    const [checkmark, setCheckmark] = useState(false);

    const handleEmailClick = () => {
        // Copy email to clipboard
        navigator.clipboard
            .writeText("jmnorheim@gmail.com")
            .then(() => {
                // Flash the email container
                setFlash(true);
                setCheckmark(true);

                // Reset after 3 seconds
                setTimeout(() => {
                    setFlash(false);
                    setCheckmark(false);
                }, 3000);
            })
            .catch((err) => {
                console.error("Failed to copy email: ", err);
            });
    };

    const isMobile = window.innerWidth <= 600;

    return (
        <div className="about-me-part-container">
            <div className="about-me-outer-content-container">
                <div className="about-me-content-left">
                    <p className="about-me-text">About Me</p>
                    <h1 className="name-heading">
                        <img src={whiteArrow} alt="arrow" className="arrow-icon-about-me-part" />
                        Jens Martin Norheim Berget{" "}
                    </h1>
                    <div className="description-container">
                        <p className="about-me-description">
                            Hi, I am a 24 year old Computer Science student from Oslo, Norway, currently studying in
                            Trondheim, Norway at the Norwegian University of Science and Technology (NTNU) with a
                            specialization in Software Systems. I am currently working part-time as an App Developer for
                            Aviant, where I am responsible for the drone delivery app Kyte Delivery{" "}
                        </p>
                        <p className="about-me-description">
                            Last semester I joined Junior Consulting, a student-driven consulting firm at NTNU, where I
                            worked part-time as a frontend-developer at Vespa.ai in Trondheim, one of the leading AI
                            Search Platform companies globally. Their technology is used by Perplexity and Spotify,
                            among others. I was also a project leader at Cogito NTNU, Norways largest student
                            organization for AI, where I lead a team that created an AI-model that can play GeoGuessr.
                        </p>
                        <p className="about-me-description">
                            Trondheim is known for its opportunities within voluntary work for students, and during my
                            studies I have been an app-developer for the{" "}
                            <a
                                href="https://uka.no"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="about-me-link"
                            >
                                UKA-festival
                            </a>
                            , the largest student festival in Norway, an AI-developer in a team at{" "}
                            <a
                                href="https://www.cogito-ntnu.no"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="about-me-link"
                            >
                                Cogito NTNU
                            </a>
                            , the largest technical student organization for AI in Trondheim, and also worked as a
                            part-time math tutor for middle-school students for{" "}
                            <a
                                href="https://vektorprogrammet.no"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="about-me-link"
                            >
                                Vektorprogrammet
                            </a>
                            , a student-led organization for students that want to inspire the younger generation to
                            start studying in STEM-related fields. More details about this can be found in the{" "}
                            <a
                                href="#projects"
                                className="about-me-link"
                                onClick={(e) => {
                                    e.preventDefault();
                                    document.getElementById("projects")?.scrollIntoView({
                                        behavior: "smooth",
                                    });
                                }}
                            >
                                Projects-section
                            </a>{" "}
                            below.
                        </p>
                        <p className="about-me-description">
                            My interest for technology goes beyond the lecture hall, which is why I have used
                            considerable amounts of my spare time in the last year developing custom projects, such as
                            an interactive pathfinding-tool along with two of my classmates at NTNU called{" "}
                            <a
                                href="https://galacticpathfinder.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="about-me-link"
                            >
                                GalacticPathFinder
                            </a>
                            , as well as this website, JMNorheim.no.
                        </p>
                        <p className="about-me-description">
                            I am always trying to learn new things and expand my knowledge, especially around the newest
                            and most bleeding-edge tech in industries like AI, robotics, electric vehicles, autonomous
                            driving, renewables, space-exploration and aviation, as well as areas like the stock-market,
                            finance, nutrition, macroeconomics, and global politics. As you can probably deduce, I am{" "}
                            <a
                                href="#interests"
                                className="about-me-link"
                                onClick={(e) => {
                                    e.preventDefault();
                                    document.getElementById("interests")?.scrollIntoView({
                                        behavior: "smooth",
                                    });
                                }}
                            >
                                interested
                            </a>{" "}
                            in a lot of things :).
                        </p>
                        <p className="about-me-description">
                            My website is in continuous development, please{" "}
                            <a
                                href="#contact"
                                className="about-me-link"
                                onClick={(e) => {
                                    e.preventDefault();
                                    document.getElementById("contact")?.scrollIntoView({
                                        behavior: "smooth",
                                    });
                                }}
                            >
                                contact me
                            </a>{" "}
                            at any time if you discover any errors or bugs, or if you just have a suggestion, and I will
                            respond as quickly as possible. I hope you enjoy my site!
                        </p>
                    </div>
                </div>
                <div className="about-me-content-right">
                    <div className="contact-info-box">
                        <div className="contact-info-content">
                            <div className="icons-and-location-container">
                                <div className="social-icons-about-me-part">
                                    <div className="github-and-linkedin-icons">
                                        <a
                                            href="https://www.linkedin.com/in/jens-martin-norheim-berget-87560b141/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={LinkedInLogo} alt="LinkedIn" className="icon-img" />
                                        </a>
                                    </div>
                                    <div className="github-and-linkedin-icons">
                                        <a
                                            href="https://github.com/jmnorheim"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={GithubLogo} alt="GitHub" className="icon-img" />
                                        </a>
                                    </div>
                                </div>
                                <div className="location-container-about-me-part">
                                    <img src={Location} alt="location" className="vuesax-linear" />
                                    <div className="text-wrapper">Trondheim & Oslo</div>
                                </div>
                            </div>
                            <div className="email-wrapper-about-me-part">
                                <div
                                    className={`email-container-about-me-part ${flash ? "email-container-flash" : ""}`}
                                    onClick={handleEmailClick}
                                >
                                    <img src={Email} alt="email" className="vuesax-linear" />
                                    <div className="email-text-about-me-part">jmnorheim@gmail.com</div>
                                    {!isMobile && (
                                        <img
                                            src={checkmark ? checkmark_icon : copy_icon}
                                            alt={checkmark ? "checkmark" : "copy"}
                                            className="copy-icon"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="education-box">
                        <div className="education-box-content-container">
                            <div className="education-box-title">My Education</div>
                            <div className="education-box-list-container">
                                {educationContent.educationList.map((education, index) => (
                                    <EducationListElement key={index} education={education} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutMePart;
